import { buildApiUrl, fetchJSON, validateRequiredParams } from './crmApi';

export interface CompanySiteInput {
  organization_id: string;
  company_id: string;
  name: string;
  phone?: string;
  address_line1?: string;
  address_line2?: string;
  city?: string;
  region?: string;
  postal_code?: string;
  country?: string;
  is_primary?: boolean;
}

export interface CompanySite extends CompanySiteInput {
  id: string;
  created_at: string;
  updated_at: string;
}

const companySitesService = {
  async list(organization_id: string, company_id: string): Promise<{ data: CompanySite[] }>{
    validateRequiredParams({ organization_id, company_id }, ['organization_id', 'company_id'], {
      service: 'companySitesService.list'
    });
    const url = buildApiUrl(`/api/crm/companies/${encodeURIComponent(company_id)}/sites`, { organization_id });
    return fetchJSON(url, {
      description: 'List company sites',
      context: { organization_id, company_id }
    });
  },
  async create(payload: CompanySiteInput): Promise<{ data: CompanySite }>{
    validateRequiredParams(payload, ['organization_id', 'company_id', 'name'], {
      service: 'companySitesService.create'
    });
    const url = buildApiUrl(`/api/crm/companies/${encodeURIComponent(payload.company_id)}/sites`);
    return fetchJSON(url, {
      method: 'POST',
      body: payload,
      description: 'Create company site',
      context: { organization_id: payload.organization_id, company_id: payload.company_id }
    });
  },
  async update(id: string, organization_id: string, updates: Partial<Omit<CompanySiteInput, 'company_id'>>): Promise<{ data: CompanySite }>{
    validateRequiredParams({ id, organization_id }, ['id', 'organization_id'], {
      service: 'companySitesService.update'
    });
    const url = buildApiUrl(`/api/crm/sites/${encodeURIComponent(id)}`);
    return fetchJSON(url, {
      method: 'PUT',
      body: { id, organization_id, ...updates },
      description: 'Update company site',
      context: { id, organization_id }
    });
  },
  async remove(id: string, organization_id: string): Promise<{ success: boolean }>{
    validateRequiredParams({ id, organization_id }, ['id', 'organization_id'], {
      service: 'companySitesService.remove'
    });
    const url = buildApiUrl(`/api/crm/sites/${encodeURIComponent(id)}`, { organization_id });
    return fetchJSON(url, {
      method: 'DELETE',
      description: 'Delete company site',
      context: { id, organization_id }
    });
  }
};

export default companySitesService;
